import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["container"]
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.containerTarget, {
      animation: 150,
      handle: "[data-photo-sort-handle]",
      ghostClass: "opacity-30",
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  persist() {
    const ids = Array.from(
      this.containerTarget.querySelectorAll("[data-photo-id]")
    ).map((el) => el.dataset.photoId)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      },
      body: JSON.stringify({ photo_ids: ids })
    })
  }
}
